import {
  AdminPanelSettings,
  AttachFile,
  BookmarkAdded,
  DashboardTwoTone,
  DateRangeRounded,
  Menu,
  Message,
  Newspaper,
  Report
} from '@mui/icons-material'
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography
} from '@mui/material'
import React, { MutableRefObject, useRef } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { SUPER_ADMIN } from 'constants/permissions'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'
import { hasPermissions } from 'utils/user'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const NivosMobileNavBarFC: React.FC<any> = (props: AppProps) => {
  const { layout, theme, user } = props
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const drawerRef: MutableRefObject<HTMLDivElement | undefined> = useRef()
  const navigate = useNavigate()

  return (
    <Box minHeight={20} position={'fixed'} zIndex={101} width={'100vw'}>
      <Paper style={{ width: '100%', margin: 0 }} elevation={3}>
        <Box
          ref={drawerRef}
          style={{
            width: '100%',
            transition: '0.5s',
            paddingTop: 4,
            marginTop: drawerOpen
              ? 0
              : drawerRef.current !== undefined
                ? drawerRef.current?.clientHeight * -1
                : 0
          }}
        >
          <Box width={1} height={1} display={'flex'} flexDirection={'column'}>
            <Box flexGrow={1}>
              <List>
                {hasPermissions(user, SUPER_ADMIN) && (
                  <ListItem>
                    <ListItemButton
                      onClick={() => {
                        setDrawerOpen(false)
                        navigate('/admin')
                      }}
                    >
                      <ListItemIcon>
                        <AdminPanelSettings color={'primary'} />
                      </ListItemIcon>
                      <ListItemText
                        primary={layout.language.translations.admin}
                      />
                    </ListItemButton>
                  </ListItem>
                )}
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/dashboard')
                    }}
                  >
                    <ListItemIcon>
                      <DashboardTwoTone color={'primary'} />
                    </ListItemIcon>
                    <ListItemText primary={'Dashboard'} />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/billboard')
                    }}
                  >
                    <ListItemIcon>
                      <Newspaper color={'primary'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={layout.language.translations.billboard}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/calendar')
                    }}
                  >
                    <ListItemIcon>
                      <DateRangeRounded color={'primary'} />
                    </ListItemIcon>
                    <ListItemText primary={'Calendar'} />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/amenity-booking')
                    }}
                  >
                    <ListItemIcon>
                      <BookmarkAdded color={'primary'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={layout.language.translations.amenityBooking}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/incident-reports')
                    }}
                  >
                    <ListItemIcon>
                      <Report color={'primary'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={layout.language.translations.incidentReports}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/documents')
                    }}
                  >
                    <ListItemIcon>
                      <AttachFile color={'primary'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={layout.language.translations.documents}
                    />
                  </ListItemButton>
                </ListItem>
                <ListItem>
                  <ListItemButton
                    onClick={() => {
                      setDrawerOpen(false)
                      navigate('/messages')
                    }}
                  >
                    <ListItemIcon>
                      <Message color={'primary'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={layout.language.translations.messages}
                    />
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
          </Box>
          <Divider variant={'middle'} />
        </Box>
        <Box bgcolor={theme.primaryColor} display={'flex'} paddingX={2}>
          <Box
            alignItems={'center'}
            justifyContent={'space-between'}
            display={'flex'}
            flexGrow={1}
            onClick={() => setDrawerOpen(!drawerOpen)}
            style={{
              cursor: 'pointer'
            }}
          >
            <IconButton>
              <Menu color={'primary'} />
            </IconButton>
            <Typography variant={'h4'} paddingLeft={1} paddingY={1}>
              Nivos
            </Typography>
            <Box display={'flex'} alignItems={'center'}>
              <Avatar src={user.image?.url} />
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const NivosMobileNavBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosMobileNavBarFC)

export default NivosMobileNavBar
